import { render } from "./vue3-lottie.vue?vue&type=template&id=614fc4cc&ts=true"
import script from "./vue3-lottie.vue?vue&type=script&lang=ts"
export * from "./vue3-lottie.vue?vue&type=script&lang=ts"

import "./vue3-lottie.vue?vue&type=style&index=0&id=614fc4cc&lang=css"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__